module.exports = __webpack_public_path__ + "img/20190601135628544.30472e30.png";